import * as requests from './requests'
import constants from './constants'
import urls from './urls'

// Consulta Email

export async function getConsultaEmails() {
  return requests
    .get(constants.API_URL_CONFIG_PORTAL, urls.GET_CONSULTA_EMAILS)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertConsultaEmail(payload) {
  return requests
    .post(constants.API_URL_CONFIG_PORTAL, urls.POST_CONSULTA_EMAIL_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateConsultaEmail(payload) {
  return requests
    .put(constants.API_URL_CONFIG_PORTAL, urls.PUT_CONSULTA_EMAIL_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteConsultaEmail(payload) {
  return requests
    .remove(constants.API_URL_CONFIG_PORTAL, `${urls.DELETE_CONSULTA_EMAIL_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

// Banner

export async function getBanners() {
  return requests.get(constants.API_URL_CONFIG_PORTAL, urls.GET_BANNERS).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function getBannersDiasSemana(payload) {
  return requests
    .get(constants.API_URL_CONFIG_PORTAL, `${urls.GET_BANNERS_DIAS_SEMANA}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertBanner(payload) {
  return requests
    .postForm(constants.API_URL_CONFIG_PORTAL, urls.POST_BANNER_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateBanner(payload) {
  return requests
    .putForm(constants.API_URL_CONFIG_PORTAL, urls.PUT_BANNER_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteBanner(payload) {
  return requests
    .remove(constants.API_URL_CONFIG_PORTAL, `${urls.DELETE_BANNER_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function getBannerById(payload) {
  return requests
    .get(constants.API_URL_CONFIG_PORTAL, `${urls.GET_BANNER_BY_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateActivarBanner(payload) {
  return requests
    .put(constants.API_URL_CONFIG_PORTAL, urls.PUT_ACTIVAR_BANNER_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateBannerSemana(payload) {
  return requests
    .put(constants.API_URL_CONFIG_PORTAL, urls.PUT_BANNER_SEMANA_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getBannerSemanaByIdiomaId(payload) {
  return requests
    .get(constants.API_URL_CONFIG_PORTAL, `${urls.GET_BANNER_SEMANA_BY_IDIOMA_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Categoria Home

export async function getCategoriaHomeByCategoriaId(payload) {
  return requests
    .get(constants.API_URL_CONFIG_PORTAL, `${urls.GET_CATEGORIA_HOME_BY_CATEGORIA_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getCategoriaHomeByEtiquetaId(payload) {
  return requests
    .get(constants.API_URL_CONFIG_PORTAL, `${urls.GET_CATEGORIA_HOME_BY_ETIQUETA_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getCategoriaHomeByFechaId(payload) {
  return requests
    .get(constants.API_URL_CONFIG_PORTAL, `${urls.GET_CATEGORIA_HOME_BY_FECHA_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertCategoriaHome(payload) {
  return requests
    .postForm(constants.API_URL_CONFIG_PORTAL, urls.POST_CATEGORIA_HOME_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateCategoriasHome(payload) {
  return requests
    .putForm(constants.API_URL_CONFIG_PORTAL, urls.PUT_CATEGORIA_HOME_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteCategoriaHome(payload) {
  return requests
    .remove(constants.API_URL_CONFIG_PORTAL, `${urls.DELETE_CATEGORIA_HOME_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function getCategoriaHomeAll(payload) {
  return requests
    .get(constants.API_URL_CONFIG_PORTAL, `${urls.GET_CATEGORIA_HOME_ALL}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getCategoriaHomeSelected(payload) {
  return requests
    .get(constants.API_URL_CONFIG_PORTAL, `${urls.GET_CATEGORIA_HOME_SELECTED}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getCategoriaEspecialSelected(payload) {
  return requests
    .get(constants.API_URL_CONFIG_PORTAL, `${urls.GET_CATEGORIA_ESPECIAL_SELECTED}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateSelectedCategoriaHome(payload) {
  return requests
    .put(constants.API_URL_CONFIG_PORTAL, urls.PUT_CATEGORIA_HOME_SELECTED_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateSelectedCategoriaEspecial(payload) {
  return requests
    .put(constants.API_URL_CONFIG_PORTAL, urls.PUT_CATEGORIA_ESPECIAL_SELECTED_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Productos Semana Home

export async function getProductosSemanaHomeSelected(payload) {
  return requests
    .get(constants.API_URL_CONFIG_PORTAL, `${urls.GET_PRODUCTOS_SEMANA_HOME_SELECTED}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateSelecteProductosSemanaHome(payload) {
  return requests
    .put(constants.API_URL_CONFIG_PORTAL, urls.PUT_PRODUCTOS_SEMANA_HOME_SELECTED_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Traduccion Pagina

export async function getTraduccionesPagina() {
  return requests
    .get(constants.API_URL_CONFIG_PORTAL, urls.GET_TRADUCCIONES_PAGINA)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertTraduccionPagina(payload) {
  return requests
    .post(constants.API_URL_CONFIG_PORTAL, urls.POST_TRADUCCION_PAGINA_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateTraduccionPagina(payload) {
  return requests
    .put(constants.API_URL_CONFIG_PORTAL, urls.PUT_TRADUCCION_PAGINA_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteTraduccionPagina(payload) {
  return requests
    .remove(constants.API_URL_CONFIG_PORTAL, `${urls.DELETE_TRADUCCION_PAGINA_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function getTraduccionPaginanByTipoId(payload) {
  return requests
    .get(constants.API_URL_CONFIG_PORTAL, `${urls.GET_TRADUCCION_PAGINA_BY_TIPO_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Menu Sitio

export async function getMenus() {
  return requests.get(constants.API_URL_CONFIG_PORTAL, urls.GET_MENUS).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function getAllMenusParents() {
  return requests
    .get(constants.API_URL_CONFIG_PORTAL, urls.GET_MENUS_PARENTS)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertMenu(payload) {
  return requests
    .postForm(constants.API_URL_CONFIG_PORTAL, urls.POST_MENU_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateMenu(payload) {
  return requests
    .putForm(constants.API_URL_CONFIG_PORTAL, urls.PUT_MENU_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteMenu(payload) {
  return requests
    .remove(constants.API_URL_CONFIG_PORTAL, `${urls.DELETE_MENU_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function getMenuById(payload) {
  return requests
    .get(constants.API_URL_CONFIG_PORTAL, `${urls.GET_MENU_BY_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getMonedaById(id) {
  return requests
    .get(constants.API_URL_CONFIG_PORTAL, `${urls.GET_MONEDA_BY_ID}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// AppSettings
export async function getAppSettings() {
  return requests
    .get(constants.API_URL_CONFIG_PORTAL, urls.GET_ALL_APPSETTINGS)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Una sola clave. Preferible a getAppSettings cuando sólo se necesitan unas pocas: el endpoint
// de todas recorre las ~126 propiedades del DTO haciendo una lectura por cada una.
export async function getAppSettingByKey(key) {
  return requests
    .get(constants.API_URL_CONFIG_PORTAL, `${urls.GET_APPSETTING_BY_KEY}/${key}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setAppSettings(payload) {
  return requests
    .post(constants.API_URL_CONFIG_PORTAL, urls.SET_APPSETTINGS, payload)
    .then(async response => {
      return { ok: response.ok, data: response }
    })
}
